// Exports
export default {
	"meetingBackButton": "meetingBackButton_fGvTS"
};
